import {lazy} from '@aboutyou/lazy-imports';

export const Wallet = lazy(() =>
  import('./Wallet.eager').then(mod => ({
    default: mod.Wallet,
  })),
);
